import { DefaultState } from 'store/reducers/types';

export const READ_RECRUITMENT_REPORT_BY_METRO_DATA_REQUEST = "READ_RECRUITMENT_REPORT_BY_METRO_DATA_REQUEST";
export const READ_RECRUITMENT_REPORT_BY_METRO_DATA_SUCCESS = "READ_RECRUITMENT_REPORT_BY_METRO_DATA_SUCCESS";
export const READ_RECRUITMENT_REPORT_BY_METRO_DATA_FAILURE = "READ_RECRUITMENT_REPORT_BY_METRO_DATA_FAILURE";

export interface RecruitmentReportByMetroRow {
  filledPercent: string;
  lastJobComment: string;
  leftCand: number;
  leftSlots: number;
  metro: string;
  metroId: number;
  neededCand: number;
  neededFromExternal: number;
  neededSlots: number;
  weight: number;
  newSignups: number;
  notCalled: number;
};

export interface RecruitmentReportByMetroData {
  rows: RecruitmentReportByMetroRow[] | [];
  totalCount: number;
};

export type RecruitmentReportByMetroState = DefaultState & {
  contents?: RecruitmentReportByMetroData;
};

interface ReadRecruitmentReportByMetroDataRequest {
  type: typeof READ_RECRUITMENT_REPORT_BY_METRO_DATA_REQUEST;
};

interface ReadRecruitmentReportByMetroDataSuccess {
  type: typeof READ_RECRUITMENT_REPORT_BY_METRO_DATA_SUCCESS;
  contents: RecruitmentReportByMetroData;
}

interface ReadRecruitmentReportByMetroDataFailure {
  type: typeof READ_RECRUITMENT_REPORT_BY_METRO_DATA_FAILURE;
}

export type ReadRecruitmentReportByMetroActionTypes = ReadRecruitmentReportByMetroDataRequest | ReadRecruitmentReportByMetroDataSuccess | ReadRecruitmentReportByMetroDataFailure;